module.exports = __webpack_public_path__ + "img/Dantam Hair 36.51fc8192.jpg";